<template>
    <div>
        
    </div>
</template>
    
<script>
import * as BABYLON from 'babylonjs';
import {mapGetters, mapState} from "vuex";

export default {
    data: () => ({
        mainNode : null,
        videoTexture: null,
        mesh: null,
	}),
    computed: {
        ...mapState({
            session: (state) => state.session.openTokSession,
            openTokStreams: (state) => state.session.openTokStreams,
            isOnboardingComplete: (state) => state.session.isOnboardingComplete,
        }),
        ...mapGetters(['scene','users','localUserID']),
	},
	methods: {
        initializeElement(){
            this.mainNode = new BABYLON.TransformNode("",this.scene); 
            this.mainNode.position = new BABYLON.Vector3(-65,5,7);
            this.mainNode.rotation = new BABYLON.Vector3(0,Math.PI*3/2,0);

            this.mesh = BABYLON.MeshBuilder.CreatePlane("ReceptionStream",{width: 26,height: 16,sideOrientation: BABYLON.Mesh.DOUBLESIDE},this.scene);
            // this.mesh.scaling = new BABYLON.Vector3(1.1,0.6,1.1);
            this.mesh.parent = this.mainNode;
            this.mesh.isPickable = false;
            this.mesh.material = new BABYLON.StandardMaterial("", this.scene);
            this.mesh.material.emissiveColor  = new BABYLON.Color3.White();
            this.mesh.materialdisableLighting = true;

            this.setVideoTexture();
        },
        setVideoTexture(){
            setInterval(() => {
                let user = this.users.find(user => user.name == 'Delia Heitmann' || user.name == 'Simon Weck');
                if(user){
                    let video = user.id == this.localUserID ? document.getElementById("video-local").querySelector("video") : document.getElementById("stream_"+user.id).querySelector("video");
                    if(video){
                        this.videoTexture = new BABYLON.VideoTexture("StreamingVideo", video, this.scene, false, false, BABYLON.TRILINEAR_SAMPLINGMODE);
                        this.mesh.material.diffuseTexture = this.videoTexture;
                        this.mainNode.setEnabled(true);
                        if(this.scene.getNodeByName("RoomContentVideo_283910"))    
                            this.scene.getNodeByName("RoomContentVideo_283910").setEnabled(false);
                        if(this.scene.getNodeByName("RoomContentVideo_283932"))
                            this.scene.getNodeByName("RoomContentVideo_283932").setEnabled(false);
                    }
                }else{
                    this.mainNode.setEnabled(false);
                    if(this.scene.getNodeByName("RoomContentVideo_283910"))    
                        this.scene.getNodeByName("RoomContentVideo_283910").setEnabled(true);
                    if(this.scene.getNodeByName("RoomContentVideo_283932"))
                        this.scene.getNodeByName("RoomContentVideo_283932").setEnabled(true);
                }
            }, 1000);
        },
        destroyElement(){
            this.mainNode.dispose();
        },
    },
    mounted: function(){
        this.initializeElement();
    },
    destroyed: function(){
        this.destroyElement();
    },
}
</script>


<style>
    
</style>